/* eslint-disable react-hooks/exhaustive-deps */

import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import DataTable from "examples/Tables/DataTable";

import { Grid } from "@mui/material";
import "./ViewOrder.scss";
import Height from "components/height/height";
import CustomText from "components/customtext/customtext";
import { useParams } from "react-router-dom";
import { appConstants } from "utils/appConstants";
import axios from "axios";
import React, { useEffect, useState } from "react";
import PageTitle from "examples/PageTitle/PageTitle";

import PageLayout from "examples/LayoutContainers/PageLayout";

function ViewOrders() {
  const { id } = useParams();
  const [rows, setRows] = useState([]);
  const [values, setValues] = React.useState({});

  useEffect(() => {
    if (id !== undefined) {
      fetchOrder();
    }
  }, []);

  const fetchOrder = async () => {
    await axios
      .post(appConstants.baseURL + "order/fetchOrderItemDetailsByID", {
        id: id,
      })
      .then((res) => {
        let response = res.data;
        console.log("fetchOrderByID(response)", response);

        if (response.Result_Output.length > 0) {
          setValues(response.Result_Output[0]);
          setRows(response.Result_Output);
        }
      })
      .catch((error) => {
        console.log("Error in fetchOrderByID=" + JSON.stringify(error));
      });
  };

  return (
    <PageLayout>
      <Height val={30} />
      <Grid container>
        {" "}
        <Grid item xs={8}>
          <Card>
            <PageTitle screenName="Order Information" />
            <Grid
              container
              px={2}
              mt={4}
              columnSpacing={2}
              justifyContent={"space-between"}
            >
              <Grid item xs={4.5}>
                <Card sx={{ backgroundColor: "aliceblue" }}>
                  <Grid container>
                    <Grid
                      item
                      xs={6}
                      style={{
                        display: "flex",
                        justifyContent: "start",
                        alignItems: "center",
                      }}
                      pl={5}
                      pt={2}
                    >
                      <CustomText type="p" size={17} style={{ color: "black" }}>
                        Order Number:
                      </CustomText>
                    </Grid>
                    <Grid
                      item
                      xs={6}
                      style={{ marginBottom: "2px" }}
                      pl={5}
                      pt={2}
                    >
                      <CustomText type="b" size={16} style={{ color: "black" }}>
                        {values.orderNumber}
                      </CustomText>
                    </Grid>
                    <Grid
                      item
                      xs={6}
                      style={{
                        display: "flex",
                        justifyContent: "start",
                        alignItems: "center",
                      }}
                      pl={5}
                      pb={2}
                    >
                      <CustomText type="p" size={17} style={{ color: "black" }}>
                        Order Date:
                      </CustomText>
                    </Grid>
                    <Grid
                      item
                      xs={6}
                      style={{ marginBottom: "2px" }}
                      pl={5}
                      pb={2}
                    >
                      <CustomText type="b" size={16} style={{ color: "black" }}>
                        {values.orderDate}
                      </CustomText>
                    </Grid>
                  </Grid>
                </Card>
              </Grid>
              <Grid item xs={4.5}>
                <Card sx={{ backgroundColor: "aliceblue" }}>
                  <Grid container>
                    <Grid
                      item
                      xs={6}
                      style={{
                        display: "flex",
                        justifyContent: "start",
                        alignItems: "center",
                      }}
                      pl={5}
                      pt={2}
                    >
                      <CustomText type="p" size={17} style={{ color: "black" }}>
                        Consignment Type:
                      </CustomText>
                    </Grid>
                    <Grid
                      item
                      xs={6}
                      style={{ marginBottom: "2px" }}
                      pl={5}
                      pt={2}
                    >
                      <CustomText type="b" size={16} style={{ color: "black" }}>
                        {values.shipmentType}{" "}
                      </CustomText>
                    </Grid>
                    <Grid
                      item
                      xs={6}
                      style={{
                        display: "flex",
                        justifyContent: "start",
                        alignItems: "center",
                      }}
                      pl={5}
                      pb={2}
                    >
                      <CustomText type="p" size={17} style={{ color: "black" }}>
                        Payment Type:
                      </CustomText>
                    </Grid>
                    <Grid
                      item
                      xs={6}
                      style={{ marginBottom: "2px" }}
                      pl={5}
                      pb={2}
                    >
                      <CustomText type="b" size={16} style={{ color: "black" }}>
                        {values.paymentType}
                      </CustomText>
                    </Grid>
                  </Grid>
                </Card>
              </Grid>
            </Grid>

            <Grid
              container
              px={2}
              mt={4}
              columnSpacing={2}
              justifyContent={"space-between"}
            >
              <Grid item xs={4.5} pl={5}>
                <Card sx={{ backgroundColor: "aliceblue" }}>
                  <Grid
                    item
                    xs={8}
                    pl={5}
                    style={{ display: "flex", alignItems: "center" }}
                    pt={3}
                  >
                    <CustomText type="b" size={17} style={{ color: "black" }}>
                      Sender Address:
                    </CustomText>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    pl={5}
                    style={{
                      display: "flex",
                      justifyContent: "start",
                      alignItems: "center",
                    }}
                  >
                    <CustomText type="p" size={17} style={{ color: "black" }}>
                      {values.senderName}
                    </CustomText>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    pl={5}
                    style={{
                      display: "flex",
                      justifyContent: "start",
                      alignItems: "center",
                    }}
                  >
                    <CustomText type="p" size={17} style={{ color: "black" }}>
                      {values.senderStreetAddress}
                    </CustomText>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    pl={5}
                    style={{
                      display: "flex",
                      justifyContent: "start",
                      alignItems: "center",
                    }}
                  >
                    <CustomText type="p" size={17} style={{ color: "black" }}>
                      {values.senderCity} , {values.senderZipCode}
                    </CustomText>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    pl={5}
                    style={{
                      display: "flex",
                      justifyContent: "start",
                      alignItems: "center",
                    }}
                  >
                    <CustomText
                      type="p"
                      size={17}
                      style={{ color: "black" }}
                    ></CustomText>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    pl={5}
                    style={{
                      display: "flex",
                      justifyContent: "start",
                      alignItems: "center",
                    }}
                  >
                    <CustomText type="p" size={17} style={{ color: "black" }}>
                      {values.senderContactNumber}
                    </CustomText>
                  </Grid>

                  <Height val={28} />
                </Card>
              </Grid>

              <Grid item xs={4.5}>
                <Card sx={{ backgroundColor: "aliceblue" }}>
                  <Grid
                    item
                    xs={8}
                    pl={5}
                    pt={3}
                    style={{
                      display: "flex",
                      justifyContent: "start",
                      alignItems: "center",
                    }}
                  >
                    <CustomText type="b" size={17} style={{ color: "black" }}>
                      Receiver Address:
                    </CustomText>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    pl={5}
                    style={{
                      display: "flex",
                      justifyContent: "start",
                      alignItems: "center",
                    }}
                  >
                    <CustomText type="p" size={17} style={{ color: "black" }}>
                      {values.receiverName}
                    </CustomText>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    pl={5}
                    style={{
                      display: "flex",
                      justifyContent: "start",
                      alignItems: "center",
                    }}
                  >
                    <CustomText type="p" size={17} style={{ color: "black" }}>
                      {values.receiverStreetAddress}
                      <br /> {values.receiverCity} , {values.receiverZipCode}
                    </CustomText>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    pl={5}
                    style={{
                      display: "flex",
                      justifyContent: "start",
                      alignItems: "center",
                    }}
                  >
                    <CustomText
                      type="p"
                      size={17}
                      style={{ color: "black" }}
                    ></CustomText>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    pl={5}
                    style={{
                      display: "flex",
                      justifyContent: "start",
                      alignItems: "center",
                    }}
                  >
                    <CustomText type="p" size={17} style={{ color: "black" }}>
                      {values.receiverContactNumber}
                    </CustomText>
                  </Grid>
                  <Height val={28} />
                </Card>
              </Grid>
            </Grid>
            <MDBox px={2}>
              <DataTable
                Header={false}
                screenName={false}
                addNew={false}
                canSearch={false}
                isSorted={true}
                entriesPerPage={false}
                showTotalEntries={false}
                pagination={true}
                noEndBorder
                table={{
                  filterable: true,
                  rows,
                  columns: [
                    {
                      Header: "No Of Items",
                      accessor: "numberOfItems",
                      align: "center",
                    },
                    {
                      Header: "Cargo Type",
                      accessor: "cargoType",
                      align: "center",
                    },
                    {
                      Header: "Description",
                      accessor: "description",
                      align: "left",
                    },
                    {
                      Header: "Weight (Kg)",
                      accessor: "weightInKg",
                      align: "center",
                    },
                    {
                      Header: "Length (mm)",
                      accessor: "lengthInMm",
                      align: "center",
                    },

                    {
                      Header: "Breadth (mm)",
                      accessor: "breadthInMm",
                      align: "center",
                    },
                    {
                      Header: "Height (mm)",
                      accessor: "heightInMm",
                      align: "center",
                    },
                  ],
                }}
              />
            </MDBox>
          </Card>
        </Grid>
      </Grid>
    </PageLayout>
  );
}

export default ViewOrders;
